/* SET STATE */
export const SET_STATE_LABREQUESTESSAY = "SET_STATE_LABREQUESTESSAY"

/* LABREQUESTESSAYS */
export const GET_LABREQUESTESSAYS = "GET_LABREQUESTESSAYS"
export const GET_LABREQUESTESSAYS_SUCCESS = "GET_LABREQUESTESSAYS_SUCCESS"
export const GET_LABREQUESTESSAYS_FAIL = "GET_LABREQUESTESSAYS_FAIL"

/* LABREQUESTESSAY */
export const GET_LABREQUESTESSAY = "GET_LABREQUESTESSAY"
export const GET_LABREQUESTESSAY_SUCCESS = "GET_LABREQUESTESSAY_SUCCESS"
export const GET_LABREQUESTESSAY_FAIL = "GET_LABREQUESTESSAY_FAIL"

/**
 * ADD LABREQUESTESSAY
 */
 export const ADD_NEW_LABREQUESTESSAY = "ADD_NEW_LABREQUESTESSAY"
 export const ADD_LABREQUESTESSAY_SUCCESS = "ADD_LABREQUESTESSAY_SUCCESS"
 export const ADD_LABREQUESTESSAY_FAIL = "ADD_LABREQUESTESSAY_FAIL"

 /**
 * UPDATE LABREQUESTESSAY
 */
export const UPDATE_LABREQUESTESSAY = "UPDATE_LABREQUESTESSAY"
export const UPDATE_LABREQUESTESSAY_SUCCESS = "UPDATE_LABREQUESTESSAY_SUCCESS"
export const UPDATE_LABREQUESTESSAY_FAIL = "UPDATE_LABREQUESTESSAY_FAIL"

/**
 * DELETE LABREQUESTESSAY
 */
export const DELETE_LABREQUESTESSAY = "DELETE_LABREQUESTESSAY"
export const DELETE_LABREQUESTESSAY_SUCCESS = "DELETE_LABREQUESTESSAY_SUCCESS"
export const DELETE_LABREQUESTESSAY_FAIL = "DELETE_LABREQUESTESSAY_FAIL"
